import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/my-coaching/profile/offers")({
  staticData: { title: "Offers" },
  component: () => <Outlet />,
});
